module.exports = __webpack_public_path__ + "img/l-2.7f42b42b.png";